/* eslint-disable import/first */
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from '@reach/router';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { generateProductRoute, generateCategoryRoute } from 'spwa-ui-library/esm/utils/path';
import { useIntl } from 'react-intl';
const { selectMenuStatus, selectFirstMenu } = Slices.menuSlice;
const { selectDesktop } = Slices.appSlice;
const { selectBaseURL, selectCountryValidations, getClusterId } = Slices.configSlice;
const { selectProductEntities, getProductInfo, fetchProductsByCategoryId } = Slices.productSlice;
const { selectDefaultAddress } = Slices.addressSlice;
import Loader from '../../components/Loader';
const { addProductToPrevCustomization } = Slices.tempCartSlice;
const { updateWithIndex, addWithoutCalculation, sendLocalCart } = Slices.cartSlice;
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import ProductCustomize from './ProductCustomize.jsx';
import {
  trackingAddedToCartGA,
  addToCartGA,
  trackingProductDetailGA,
  trackingProductViewGA,
} from 'spwa-ui-library/esm/utils/helperGA';
const { selectCurrentCountry } = Slices.profileSlice;

import SeoTitle from './../../components/SeoTitle/index';
import css from './index.module.scss';
import Deal from '../Deal';
import {
  areObjectsSame,
  getRemovedItems,
  getAddedItems,
  getSelectedItem,
  getVariantDetails,
} from 'spwa-ui-library/esm/utils/helper';
const { selectCategoryEntities } = Slices.categorySlice;
const {
  addProductToCustomize,
  updateProductPayload,
  setBundleCustomisedData,
} = Slices.tempCartSlice;
function Product({
  onAddToCart,
  locale,
  encodedCategoryName,
  categoryID,
  encodedProductName,
  productID,
}) {
  const dispatch = useDispatch();
  const intl = useIntl();
  const navigateHook = useNavigate();
  const location = useLocation();

  const clusterId = useSelector(getClusterId);

  const categoryList = useSelector((state) => state.category);
  const locationSearch = new URLSearchParams(location.search);
  const isBundleItem = locationSearch.has('main_product') || false;
  const mainProductId = locationSearch.get('main_product'); // used when main product is a deal and we're customizing a step.
  const stepId = locationSearch.get('step'); // used when main product is a deal and we're customizing a step.

  const locationData = location?.state?.oldLocation?.state?.retUrl
    ? location?.state?.oldLocation?.state
    : location?.state;

  const retUrl =
    locationData?.retUrl ||
    (location?.state?.oldLocation?.pathname
      ? location?.state?.oldLocation?.pathname
      : `/${intl.locale}/home`);

  const isDesktop = useSelector(selectDesktop);
  const productsMap = useSelector(selectProductEntities);
  const menuStatus = useSelector(selectMenuStatus);

  let productObj =
    productsMap[productID] ||
    productsMap[mainProductId]?.steps
      ?.find((step) => step.id == stepId)
      ?.options?.find((option) => option?.id == productID);

  if (!productObj) {
    productObj = productsMap[mainProductId];
  }

  const customizeItem = useSelector((state) => state.tempCart);
  const address = useSelector(selectDefaultAddress);

  const menu = useSelector(selectFirstMenu);
  const categories = useSelector(selectCategoryEntities);
  const [errorAddCart, setErrorAddCart] = useState('');
  const [errorStatus, setErrorStatus] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const country = useSelector(selectCurrentCountry);
  const imgBaseUrl = useSelector(selectBaseURL);
  let mainProduct = [];
  mainProduct[0] = Object.assign({}, productObj);
  const [selectedSize, setSelectedSize] = useState(null);
  const [custID, setCustID] = useState(productID);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const [optMainId, setOptMainId] = useState(null);
  const [refArray, setRefArray] = useState([]);
  const [resetDependent, SetResetDependent] = useState(false);

  function generateBundleItemsData(productCustomization, productObj, price = 0) {
    const generatedData = {
      productName: productObj?.name,
      productDescription: productObj?.description,
      productId: productObj?.id,
      variantsInfo: getVariantDetails(productCustomization, productObj),
      items: [],
    };
    let selectedItem = getSelectedItem(productCustomization, productObj);
    let addedProductItems = getAddedItems(productCustomization, selectedItem);
    let removedProductItems = getRemovedItems(productCustomization, selectedItem);
    let additionPrice = price - (selectedItem?.specialPrice || selectedItem?.originalPrice || 0);

    if (
      Object.keys(addedProductItems || {}).length ||
      Object.entries(removedProductItems).length ||
      additionPrice
    ) {
      generatedData.items.push({
        addedProductItems,
        removedProductItems,
        additionPrice,
      });
    }

    return generatedData;
  }

  useEffect(() => {
    let item = customizeItem.data.items.find(({ id }) => id == (mainProductId || productID));
    if (productObj && productObj?.bundleTypeId != 'simple' && !item) {
      if (!productObj && locationSearch.has('main_product')) {
        productObj = productsMap[locationSearch.get('main_product')];
      }

      let shouldDispatchAction = true;
      if (
        productObj?.bundleTypeId == 'bundle' &&
        productObj?.typeId == 'simple' &&
        !productObj?.steps?.[0]?.items
      ) {
        shouldDispatchAction = false;
      }

      if (shouldDispatchAction) {
        console.log(`disoatching with data -- `, {
          productType: productObj?.bundleTypeId,
          updatedOn: new Date().getTime(),
          mainProductId: productObj?.id,
          data: {
            ...productObj,
            category: categoryID == 999 ? productObj?.categories?.[0] : categoryID,
            noIncrement: true,
          },
        });

        dispatch(
          addProductToCustomize({
            productType: productObj?.bundleTypeId,
            updatedOn: new Date().getTime(),
            mainProductId: productObj?.id,
            data: {
              ...productObj,
              category: categoryID == 999 ? productObj?.categories?.[0] : categoryID,
              noIncrement: true,
            },
          })
        );
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      }
    }
  }, [productObj]);

  useEffect(() => {
    try {
      var element = document.getElementById('titleDig');
      if (element) element.classList.add(css.centerPage);
    } catch (error) {
      console.log(error);
    }
  }, []);
  // REV : add to cart function
  const addCart = () => {
    setPageLoader((prev) => true);

    const originalProduct = productsMap[isBundleItem ? mainProductId : productID];
    if (originalProduct?.typeId == 'simple' && originalProduct?.bundleTypeId == 'simple') {
      const prodPrice =
        originalProduct?.price >= 0
          ? originalProduct?.price
          : originalProduct?.specialPrice || originalProduct?.originalPrice || 0;

      dispatch(
        sendLocalCart({
          productType: originalProduct.bundleTypeId,
          updatedOn: new Date().getTime(),
          mainProductId: originalProduct.id,
          data: {
            ...originalProduct,
            specialPrice: prodPrice,
            category: originalProduct?.categories?.[0],
          },
        })
      );

      navigateUser(prodPrice, { qty: 1 });
      return;
    }

    let payload = customizeItem.data?.items?.find(
      ({ id }) => id === +(isBundleItem ? mainProductId : productID)
    );
    payload = JSON.parse(JSON.stringify(payload || {}));
    if (payload.editDesc) {
      delete payload['editDesc'];
    }

    console.log(`initial payload -- `, payload);

    // get price Variant
    let currentVariation, currentProductVariation;
    let variationArray = [-1, -1, -1];
    if (!isBundleItem) {
      Object.values(payload?.variants || {}).forEach((variant, index) => {
        variationArray[index] = variant;
      });

      currentProductVariation = productObj?.items?.find((item) => {
        let isVariantSame = true;
        variationArray.forEach((variant, index) => {
          if (item[`sel${index + 1}Value`] != variant) {
            isVariantSame = false;
          }
        });
        return isVariantSame;
      });

      currentProductVariation = productObj?.items?.find((item) => {
        let isVariantSame = true;
        variationArray.forEach((variant, index) => {
          if (item[`sel${index + 1}Value`] != variant) {
            isVariantSame = false;
          }
        });
        return isVariantSame;
      });
    } else {
      const stepInfo = productsMap[mainProductId]?.steps?.find((step) => step?.id == stepId);
      const productInfo = stepInfo?.options?.find((option) => option?.id == productID);

      if (payload?.bundle?.[stepId]?.[productID]?.variants) {
        Object.values(payload?.bundle?.[stepId]?.[productID]?.variants).forEach(
          (variant, index) => {
            variationArray[index] = variant;
          }
        );
      } else {
        Object.values(productInfo?.variants || {}).forEach((variant, index) => {
          const selectedOption = variant?.options?.find((option) => option?.isSelected == 1);
          if (selectedOption) {
            variationArray[index] = selectedOption?.id;
          }
        });
      }

      currentProductVariation = productInfo?.items?.find((item) => {
        let isVariantSame = true;
        variationArray.forEach((variant, index) => {
          if (item[`sel${index + 1}Value`] != variant) {
            isVariantSame = false;
          }
        });
        return isVariantSame;
      });
    }

    if (!currentProductVariation) {
      currentProductVariation = productsMap[isBundleItem ? mainProductId : productID];
    }

    // add base price -
    let finalPrice =
      currentProductVariation?.specialPrice || currentProductVariation?.originalPrice || 0;

    // add price for additional items such as sauce and toppings
    if (isBundleItem) {
      for (let step of currentProductVariation?.steps || []) {
        for (let option of step?.options) {
          if (option?.subOptions) {
            finalPrice +=
              option?.subOptions[
                payload?.bundle?.[stepId]?.[productID]?.items?.[step.id]?.[option.id]?.['qty'] - 1
              ]?.price || 0;
          } else {
            if (payload?.bundle?.[stepId]?.[productID]?.items?.[step.id]?.[option.id]?.['qty']) {
              finalPrice +=
                (option?.price || 0) *
                Number(
                  payload?.bundle?.[stepId]?.[productID]?.items?.[step.id]?.[option.id]?.['qty'] ||
                    0
                );
            }
          }
        }
      }
    } else {
      for (let step of currentProductVariation?.steps || []) {
        for (let option of step?.options) {
          if (option?.subOptions) {
            finalPrice +=
              option?.subOptions[payload?.items?.[step.id]?.[option.id]?.['qty'] - 1]?.price || 0;
          } else {
            if (payload?.items?.[step.id]?.[option.id]?.['qty']) {
              finalPrice +=
                (option?.price || 0) * Number(payload?.items?.[step.id]?.[option.id]?.['qty'] || 0);
            } else if (payload?.['bundle']?.[step.id]?.[option.id]?.['qty']) {
              finalPrice +=
                (option?.price || 0) *
                Number(payload?.['bundle']?.[step.id]?.[option.id]?.['qty'] || 0);
            }
          }
        }
      }
    }

    // add product in temp.customization if items are different than default configuration
    if (!isBundleItem) {
      let defaultCustomizationItem = {};
      (currentProductVariation?.steps || []).forEach((step) => {
        let stepItems = {};
        (step?.options || []).forEach((option) => {
          if (option?.subOptions) {
            let selectedSubOptions =
              option?.subOptions?.filter(
                (subOption) => subOption?.default == 1 || subOption?.selected == 1
              )?.length || 0;

            if (selectedSubOptions > 0) {
              stepItems[option?.id] = { qty: selectedSubOptions };
            }
          } else {
            if (option?.default || option?.selected) {
              stepItems[option?.id] = { qty: 1 };
            }
          }
        });
        if (Object.values(stepItems).length) {
          defaultCustomizationItem[step?.id] = stepItems;
        }
      });

      if (!areObjectsSame(defaultCustomizationItem, payload?.items)) {
        payload = JSON.parse(JSON.stringify(payload || {}));
        delete payload['notAdded'];
        dispatch(
          addProductToPrevCustomization({
            id: payload?.id,
            data: { ...payload, price: finalPrice * (payload?.qty || 1) },
          })
        );
      }
    }
    const generatedData = generateBundleItemsData(payload, productObj, finalPrice);
    if (generatedData) {
      dispatch(setBundleCustomisedData(generatedData));
    }

    if (
      currentProductVariation?.bundleTypeId == 'bundle' &&
      currentProductVariation?.typeId == 'simple'
    ) {
      payload['typeId'] = 'simple';
      payload['items'] = payload['bundle'];
      delete payload['bundle'];
    }

    if (locationSearch.has('cartId')) {
      if (productsMap[mainProductId]?.typeId == 'bundle_group') {
        payload = JSON.parse(JSON.stringify(payload || {}));
        payload[`parentId`] = mainProductId;
      }

      dispatch(
        updateWithIndex({
          index: locationSearch.get('cartId'),
          productPayload: {
            ...payload,
            price: finalPrice * (payload?.qty || 1),
          },
        })
      );
    } else {
      dispatch(addWithoutCalculation({ ...payload, product: productsMap[productID] }));
    }

    if (onAddToCart) {
      onAddToCart();
    }

    navigateUser(finalPrice, payload);
  };

  const navigateUser = (finalPrice, payload) => {
    setTimeout(() => {
      setPageLoader(false);
      if (locationSearch.has('cartId')) {
        navigateHook(`/${intl.locale}/cart`, { replace: true });
      } else if (retUrl) {
        navigateHook(retUrl);
      } else {
        navigateHook(`/${encodedCategoryName}/${categoryID}`);
      }
    }, 0);

    const selectedCategory = categories[categoryID];
    // debugger;
    const GAProduct = {
      sellingPrice: finalPrice * (payload?.qty || 1),
      catId: categoryID,
      ...mainProduct[0],
    };
    addToCartGA(
      GAProduct,
      countryValidations?.currency,
      GAProduct?.name || '',
      'ProductDetailPage'
    );
    trackingAddedToCartGA(
      GAProduct,
      countryValidations?.currency,
      selectedCategory?.name || '',
      address
    );
  };

  useEffect(() => {
    trackingProductDetailGA(mainProduct[0], encodedCategoryName);
    trackingProductViewGA(mainProduct[0], countryValidations?.currency, encodedCategoryName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const executeScroll = (ref) => {
    ref.current.scrollIntoView();
  };

  const customizeIndex = customizeItem.data.items.findIndex(({ id }) => id === custID);

  const resetAddOns = () => {
    if (isBundleItem) {
      // update bundle in tempCart data for step -
      const productCustomization = customizeItem.data.items.find(
        (product) => product.id == mainProductId
      );

      const newProductCustomization = JSON.parse(JSON.stringify(productCustomization || {}));

      // generate correct product object
      let stepInfo;
      if (
        productsMap[mainProductId]?.isBOGO ||
        productsMap[mainProductId]?.bundleTypeId == 'bundle_group'
      ) {
        const paramsStepId = parseInt(locationSearch.get('step'));
        const optionId = parseInt(locationSearch.get('option'));

        let bgSteps = productsMap[mainProductId]?.items?.find((item) => {
          let itemInfo;
          if (!item?.id) {
            itemInfo = productsMap[item];
          } else {
            itemInfo = item;
          }

          return itemInfo?.id == optionId || itemInfo?.sel1Value == optionId;
        });

        if (!bgSteps?.id) {
          bgSteps = productsMap[bgSteps];
        }

        if (!Array.isArray(bgSteps?.steps) || !bgSteps?.steps?.length) {
          bgSteps = productsMap[bgSteps?.id];
        }

        stepInfo = bgSteps?.steps?.find((step) => step?.id == paramsStepId);
      } else {
        stepInfo = productsMap[mainProductId]?.steps?.find((step) => step?.id == stepId);
      }

      let productInfo;
      if (isBundleItem) {
        productInfo = stepInfo?.options?.find((option) => option?.id == productID);
      } else {
        productInfo = productObj;
      }

      // generate correct object for step ID
      let variants = {},
        itemPayload = { qty: 1 },
        variationArray = [-1, -1, -1];

      // eslint-disable-next-line no-unused-expressions
      productInfo?.variants?.forEach((variant, index) => {
        const selectedOption = variant?.options.find((option) => option.isSelected == 1);
        if (selectedOption) {
          variants[variant.id] = selectedOption.id;
          variationArray[index] = selectedOption.id;
        }
      });
      itemPayload['variants'] = variants;

      // contains items such as toppings, add them
      if (Array.isArray(productInfo?.items) && productInfo?.items?.length > 0) {
        let selectedItemIndex = -1;
        // eslint-disable-next-line no-unused-expressions
        productInfo?.items?.forEach((item, i) => {
          let itemInfo;
          if (item?.id) {
            itemInfo = item;
          } else {
            itemInfo = productsMap[item];
          }
          let areVariationsSame = true;
          variationArray.forEach((value, index) => {
            if (itemInfo[`sel${index + 1}Value`] != value) {
              areVariationsSame = false;
            }
          });

          if (areVariationsSame) {
            selectedItemIndex = i;
          }
        });

        if (selectedItemIndex > -1) {
          let items = {};
          // eslint-disable-next-line no-unused-expressions
          let productItemsObj = productInfo?.items[selectedItemIndex];
          if (!productItemsObj?.id) {
            productItemsObj = productsMap[productItemsObj];
          }
          if (!productItemsObj?.steps?.[0]?.options) {
            productItemsObj = productsMap[mainProductId]?.steps
              ?.find((step) => step.id == stepId)
              ?.options?.find((option) => option?.id == productID)
              ?.items?.find((item) => item?.id == productItemsObj?.id);
          }

          // bogo
          if (!productItemsObj && productsMap[mainProductId]?.isBOGO) {
            productItemsObj = productInfo?.items?.[selectedItemIndex || 0];
            if (!productItemsObj?.steps?.[0]?.options) {
              productItemsObj = productsMap[productInfo?.id]?.items?.find(
                (item) => item?.id == productItemsObj?.id
              );
            }
          }

          (productItemsObj?.steps || []).forEach((step) => {
            items[step.id] = {};
            // eslint-disable-next-line no-unused-expressions
            step?.options?.forEach((option) => {
              if (option?.subOptions) {
                const selectedSubOptions = option?.subOptions?.filter(
                  (subOption) => subOption.selected == 1
                );
                if (selectedSubOptions?.length > 0) {
                  items[step.id][option.id] = {
                    qty: selectedSubOptions?.length,
                  };
                }
              } else {
                if (option?.selected == 1) {
                  items[step.id][option.id] = {
                    qty: 1,
                  };
                }
              }
            });
            if (!Object.keys(items[step.id]).length) delete items[step.id];
          });

          let finalItems = {};
          for (let [keys, vals] of Object.entries(items)) {
            if (vals) {
              finalItems[keys] = vals;
            }
          }

          if (Object.keys(finalItems)?.length) itemPayload['items'] = finalItems;
        }
      }

      if (!newProductCustomization?.['bundle']?.[stepId]) {
        newProductCustomization['bundle'][stepId] = {};
      }

      newProductCustomization['bundle'][stepId][productInfo.id] = itemPayload;

      dispatch(
        updateProductPayload({
          data: newProductCustomization,
        })
      );
    } else {
      dispatch(
        addProductToCustomize({
          productType: productObj.bundleTypeId,
          updatedOn: new Date().getTime(),
          mainProductId: productObj.id,
          data: {
            ...productObj,
            category: categoryID == 999 ? productObj?.categories[0] : categoryID,
            noIncrement: true,
          },
        })
      );
    }
  };

  const menuItem = productObj || {};
  useEffect(() => {
    if (menuStatus === 'succeeded' && !productsMap[isBundleItem ? mainProductId : productID]) {
      setTimeout(() => {
        dispatch(
          fetchProductsByCategoryId({
            id: categoryID,
            cluster: clusterId,
            Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
          })
        ).then((catData) => {
          dispatch(
            getProductInfo({
              id: isBundleItem ? mainProductId : productID,
              cluster: clusterId,
              service: address?.addressSubType || 'DELIVERY',
              categoryId: categoryID,
              Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
            })
          ).then((resp) => {
            if (!resp?.payload || Object.values(resp?.payload || {}).length < 2) {
              navigateHook(`/${intl.locale}/home`);
            } else {
              let lastRefresh =
                window.localStorage.getItem('refreshedOn', new Date().getTime()) || '';
              let [prodId = 0, lastRefreshOn = 0] = lastRefresh.split('-');

              let timeDifference = new Date().getTime() - parseFloat(lastRefreshOn);

              if (!lastRefreshOn && timeDifference >= 10000) {
                dispatch(
                  addProductToCustomize({
                    productType: resp?.payload?.bundleTypeId,
                    updatedOn: new Date().getTime(),
                    mainProductId: resp?.payload?.id,
                    data: {
                      ...resp?.payload,
                      category: categoryID == 999 ? resp?.payload?.categories?.[0] : categoryID,
                      noIncrement: true,
                    },
                  })
                );

                window.localStorage.setItem(
                  'refreshedOn',
                  `${resp.payload.id}-${new Date().getTime()}`
                );

                const mainProductObj = resp?.payload;
                if (locationSearch.has(`main_product`) && mainProductObj?.typeId != 'simple') {
                  // calculate previous path -
                  const category = categoryList.entities[mainProductObj?.['categories']?.[0]];

                  let productRoute = generateProductRoute({
                    product: mainProductObj,
                    category,
                    locale: intl.locale.toLowerCase(),
                  });
                  productRoute = `${productRoute}/bundle`;

                  if (!category || !mainProductObj) {
                    productRoute = `/home`;
                  }

                  window.location.href = productRoute;
                }
              }
            }
          });
        });
      }, 1000);
    }
    if (!location?.state?.oldLocation && isDesktop && menuStatus === 'succeeded' && productObj) {
      const currentCat = categories[categoryID];
      const path = generateCategoryRoute({ category: currentCat, locale });
      const oldLocation = { ...location, href: location.origin, pathname: path };
      const searchBar = location?.search;
      navigateHook(
        `/${locale}/${encodedCategoryName}/${categoryID}/${encodedProductName}/${productID}${searchBar}`,
        {
          replace: true,
          state: {
            oldLocation,
            description: intl.formatMessage({ id: 'customize_your_meals' }),
          },
        }
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuStatus, productID, productObj]);

  if (
    productObj &&
    Object.keys(productObj).length &&
    productObj['typeId'] === 'bundle' &&
    !isBundleItem
  ) {
    return <Deal />;
  }

  return !productObj ? null : (
    <>
      {!isBundleItem && (
        <SeoTitle
          id="product"
          productname={productObj.name}
          submenuname={categories[categoryID]?.name}
          overRideMeta={productObj}
        />
      )}
      <Snackbar
        open={errorStatus}
        autoHideDuration={6000}
        onClose={() => setErrorStatus(false)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Alert onClose={() => setErrorStatus(false)} severity="error" sx={{ width: '100%' }}>
          {errorAddCart}
        </Alert>
      </Snackbar>
      {!isDesktop && (
        <div className={css.root}>
          {pageLoader && <Loader />}
          {/* <Header
            title={menuItem.name}
            actionButtons={[
              // <LanguageButton />,
              <Button
                variant="outlined"
                size="small"
                className={css.resetBtn}
                onClick={resetAddOns}
              >
                <FormattedMessage id="customize_reset" defaultMessage="Reset" />
              </Button>,
            ]}
          /> */}
          <ProductCustomize
            setOptMainId={setOptMainId}
            isBundleItem={isBundleItem}
            SetResetDependent={SetResetDependent}
            resetDependent={resetDependent}
            menuItem={menuItem}
            executeScroll={executeScroll}
            refArray={refArray}
            imgBaseUrl={imgBaseUrl}
            selectedProduct={productObj}
            setSelectedSize={setSelectedSize}
            setRefArray={setRefArray}
            addCart={addCart}
            customizeItem={customizeItem}
            customizeIndex={customizeIndex}
            productID={productID}
            categoryID={categoryID}
            resetButton={resetAddOns}
          />
        </div>
      )}
      {isDesktop && (
        <>
          {pageLoader && <Loader />}
          <div className={css.desktopWrapper}>
            <ProductCustomize
              setOptMainId={setOptMainId}
              SetResetDependent={SetResetDependent}
              resetDependent={resetDependent}
              menuItem={menuItem}
              isDesktop={isDesktop}
              executeScroll={executeScroll}
              refArray={refArray}
              imgBaseUrl={imgBaseUrl}
              selectedProduct={productObj}
              setSelectedSize={setSelectedSize}
              setRefArray={setRefArray}
              addCart={addCart}
              productID={productID}
              customizeItem={customizeItem}
              customizeIndex={customizeIndex}
              resetButton={resetAddOns}
            />
          </div>
        </>
      )}
    </>
  );
}

export default Product;
